import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ConfirmEmailComponent } from '@app/modules/user/pages/confirm-email/confirm-email.component';
import { SharedModule } from '@app/shared/shared.module';
import { CloseComponent, ConfettiComponent, LoadingSpinnerComponent } from '@ui';
import { ForgotPwFormComponent } from './components/forgot-pw-form/forgot-pw-form.component';
import { LoginFormComponent } from './components/login-form/login-form.component';
import { LogoutComponent } from './components/logout/logout.component';
import { MagicLinkInputComponent } from './components/magic-link-input/magic-link-input.component';
import { MagicLinkSuccessComponent } from './components/magic-link-success/magic-link-success.component';
import { UserHeaderComponent } from './components/user-header/user-header.component';
import { CsLoginComponent } from './pages/cs-login/cs-login.component';
import { HostInviteSuccessDoneComponent } from './pages/host-invite-success-done/host-invite-success-done.component';
import { HostInviteSuccessComponent } from './pages/host-invite-success/host-invite-success.component';
import { HostInviteComponent } from './pages/host-invite/host-invite.component';
import { InviteComponent } from './pages/invite/invite.component';
import { LoginComponent } from './pages/login/login.component';
import { MagicLinkLoginComponent } from './pages/magic-link-login/magic-link-login.component';
import { PasswordSetComponent } from './pages/password-set/password-set.component';
import { UserRoutingModule } from './user-routing.module';

@NgModule({
  declarations: [
    LoginComponent,
    LoginFormComponent,
    ForgotPwFormComponent,
    CsLoginComponent,
    PasswordSetComponent,
    InviteComponent,
    UserHeaderComponent,
    HostInviteComponent,
    HostInviteSuccessComponent,
    HostInviteSuccessDoneComponent,
    MagicLinkSuccessComponent,
    MagicLinkInputComponent,
    MagicLinkLoginComponent,
    LogoutComponent,
    ConfirmEmailComponent,
  ],
  imports: [CommonModule, SharedModule, UserRoutingModule, LoadingSpinnerComponent, ConfettiComponent, CloseComponent],
})
export class UserModule {}
